import { Chip } from "@mui/material";
import { formatDate } from "../../../helpers/formatingFunctions";

export const recruitingContactsTableColumns = [
  {
    field: "contactDate",
    headerName: "Contact Date",
    width: 140,
    valueFormatter: (value: string) => (value ? formatDate(value) : ""),
  },
  {
    field: "name",
    headerName: "Applicant",
    width: 220,
  },
  {
    field: "status",
    headerName: "Status",
    width: 160,
    renderCell: (params: any) => {
      const rawStatus = params?.value ?? params?.row?.status;
      const status = String(rawStatus ?? "").trim();
      const normalized = status.toLowerCase();

      const color =
        normalized === "hired"
          ? "success"
          : normalized.includes("declin") || normalized.includes("reject")
            ? "error"
            : normalized.includes("pending") || normalized.includes("follow")
              ? "warning"
              : "info";

      return (
        <Chip
          size="small"
          label={status || "Unknown"}
          color={color}
          variant="filled"
        />
      );
    },
  },
  {
    field: "primaryPhone",
    headerName: "Primary Phone",
    width: 150,
  },
  {
    field: "secondaryPhone",
    headerName: "Secondary Phone",
    width: 150,
  },
  {
    field: "statusReason",
    headerName: "Reason",
    width: 260,
  },
];
